import { Record } from 'immutable';

export interface PaginationInterface {
  pageNumber: number;
}

const pageNumber = 0;

export const initialState: PaginationInterface = {
  pageNumber: pageNumber
};

export default class PaginationState extends Record(initialState) { }
